import React, { memo, useContext } from "react"
import AlertService from "../../../../Services/AlertService";
import ApiService from "../../../../Services/ApiService";
import { Button } from "react-bootstrap";
import { useParams } from "react-router-dom"
import { FaRegCopy } from "react-icons/fa6";
import { useSelector } from "react-redux";
import PaymentDataContext from '../../../../PaymentDataContext.jsx';

const MainPrice = memo(({ price, selectedChain, selectedToken, getPaymentData }) => {

    const { paymentData } = useContext(PaymentDataContext);
    const { cancelUrl } = useSelector(state => state.main);
    const { token } = useParams();
    let _cancelUrl = cancelUrl || localStorage.getItem("cancelUrl") || null;

    const cancelPayment = () => {
        AlertService.alertConfirm(
            `Payment cancellation`,
            "Are you sure you want to cancel this payment?",
            "Yes",
            "No"
        ).then(() => {
            ApiService.cancelPayment(token).then(() => {
                if (_cancelUrl) {
                    const cancelUrlValue = localStorage.getItem("cancelUrl") || null;
                    localStorage.clear();
                    if (cancelUrlValue !== null) {
                        localStorage.setItem("cancelUrl", cancelUrlValue);
                    }
                    window.location.replace(_cancelUrl);
                } else {
                    getPaymentData && getPaymentData(null, false)
                }
            }).catch(error => error && AlertService.alert("error", error));
        }).catch(() => { });
    };

    return <div className="main-information">
        <div className={`main-information-item ${!_cancelUrl ? "h-100" : ""}`}>
            <div className="mb-3 title-block">
                <strong >Main Information</strong>
            </div>
            <div className="cx-window-body-container">

                <div className="info-block">
                    <div className="text-muted text-nowrap">Order</div>
                    <div className="dotes w-100" />
                    <div className="d-flex gap-2 align-items-center">
                        {
                            paymentData && paymentData.remoteTransactionId ? (
                                <div className="text-muted">
                                    {`${paymentData.remoteTransactionId.slice(0, 4)}...${paymentData.remoteTransactionId.slice(-2)}`}
                                </div>
                            ) : (
                                <div className="text-muted text-nowrap">Not set</div>
                            )
                        }
                        <div
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                                navigator.clipboard.writeText(paymentData.remoteTransactionId);
                                AlertService.alert("success", "Copied!")
                            }}>
                            <FaRegCopy size={16} className="mb-2" color="#6c757d" />
                        </div>
                    </div>
                </div>
                <div className="info-block mt-2">
                    <div className="text-muted text-nowrap">Network</div>
                    <div className="dotes w-100" />
                    <div className="text-muted text-nowrap">
                        {
                            selectedChain ?
                                <div className="d-flex gap-2 align-items-center">
                                    <img src={selectedChain.currencyLogo} width={20} className="rounded" />
                                    <span>{selectedChain.chainName}</span>
                                </div>
                                : "Not set"
                        }
                    </div>
                </div>
                <div className="info-block mt-2">
                    <div className="text-muted text-nowrap">Token</div>
                    <div className="dotes w-100" />
                    <div className="text-muted text-nowrap">
                        {
                            selectedToken ?
                                <div className="d-flex gap-2 align-items-center">
                                    <img src={selectedToken.logo} width={20} className="rounded" />
                                    <span>{selectedToken?.slug}</span>
                                </div>
                                : "Not set"
                        }
                    </div>
                </div>
                <div className="info-block mt-2">
                    <div className="text-muted text-nowrap">Transaction Value</div>
                    <div className="dotes w-100" />
                    <div className="text-muted text-nowrap">
                        {paymentData && paymentData.fiatAmount ? `$ ${paymentData.fiatAmount}` : ""}
                    </div>
                </div>

                {/* <div className="info-block mt-2">
                    <div className="text-muted text-nowrap">Commission </div>
                    <div className="dotes w-100" />
                    <div className="text-muted text-nowrap">
                        {price && paymentData && paymentData.fiatAmount ? `$ ${(+price - +paymentData.fiatAmount).toFixed(4)}` : "Not set"}
                    </div>
                </div> */}

                {/* <div className="info-block mt-2">
                    <div className="text-muted text-nowrap">Exchange rate</div>
                    <div className="dotes w-100" />
                    <div className="text-muted text-nowrap">
                        {
                            tick ?
                                <span id="currenttick">$ {tick.toFixed(2)}</span>
                                : "Not set"
                        }
                    </div>
                </div> */}
                <div className="info-block mt-2">
                    <div className="text-nowrap text-danger">Total</div>
                    <div className="dotes w-100" style={{ borderBottomColor: "#DC3545" }} />
                    <div className="text-danger text-nowrap">
                        {
                            price ?
                                <div className="d-flex align-items-center gap-2">
                                    <span>
                                        {
                                            selectedToken ?
                                                <span>{selectedToken?.slug}{" "}</span>
                                                : null
                                        }
                                        {+price.toFixed(4)}
                                    </span>
                                </div>
                                : "Not set"
                        }
                    </div>
                </div>
                {
                    paymentData && paymentData.transactionText ?
                        <div className="mt-4 title-block">
                            <strong >Transaction Text</strong>
                            <p className="mt-2">
                                {paymentData && paymentData.transactionText ? paymentData.transactionText : ""}
                            </p>
                        </div>
                        : null
                }
                {
                    paymentData && paymentData.paymentProductInfo && paymentData.paymentProductInfo.length ?
                        <React.Fragment>
                            <div className="mt-4 title-block">
                                <strong >Payment information</strong>
                            </div>
                            <div className="cx-orders-container flex-column d-flex gap-2 overflow-auto mt-3">
                                {
                                    paymentData.paymentProductInfo.map((el, index) => {
                                        return <div key={index} className="cx-order-wrapper">
                                            <img src={el.imageUrl} alt={el.name} />
                                            {
                                                el.description ?
                                                    <p className="cx-order-desction">{el.description}</p>
                                                    : null
                                            }
                                            <div className="cx-order-price">
                                                {
                                                    el.cost ?
                                                        <strong>
                                                            <span>$</span>{el.cost}
                                                        </strong>
                                                        : null
                                                }
                                            </div>
                                        </div>
                                    })
                                }
                            </div>
                        </React.Fragment>
                        : null
                }

                {/* {
                <div className="cx-company-name-wrapper">
                    {
                        organizationData && organizationData.logoImage && organizationData.logoImage ?
                            <img src={organizationData.logoImage} alt="Organization logo" />
                            : null
                    }
                    {
                        organizationData && organizationData.organizationName && organizationData.organizationName ?
                            <p style={{ marginLeft: organizationData.logoImage ? "20px" : 0 }}>{organizationData.organizationName}</p>
                            : null
                    }
                </div>
            } */}
            </div>
        </div>
        <div className="cancel-payment-block">
            <Button
                size="sm"
                variant="danger"
                className="px-3"
                onClick={cancelPayment}
            >
                Cancel Payment
            </Button>
        </div>
    </div>
})



export default MainPrice